import { connect } from 'react-redux'
import { findMenus } from '../actions/menus'
import LocatedMenu from '../components/LocatedMenu'

const mapStateToProps = (state, ownProps) => ({
  entities: state.entities.menus, // FIXME: it is not necessary to forward all menus entities to component
  menus: state.menus // FIXME: it is not necessary to forward all menus from state to component
})

const mapDispatchToProps = {
  findMenus
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocatedMenu)



// WEBPACK FOOTER //
// ./src/containers/LocatedMenu.js